import { render, staticRenderFns } from "./List.vue?vue&type=template&id=663026d6&scoped=true&lang=html&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663026d6",
  null
  
)

export default component.exports